import { render, staticRenderFns } from "./QrcRouter.vue?vue&type=template&id=96f8169e&scoped=true"
import script from "./QrcRouter.vue?vue&type=script&lang=js"
export * from "./QrcRouter.vue?vue&type=script&lang=js"
import style0 from "./QrcRouter.vue?vue&type=style&index=0&id=96f8169e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f8169e",
  null
  
)

export default component.exports